import React from "react";
import {Svg, G, Path, Rect} from "react-primitives-svg";
import PropTypes from "prop-types";
import {svgSize} from "../helpers/svg";
import {Colors} from "./HSL_COLORS";

export default function Icon({fill, height, width, ...rest}) {
  return (
    <Svg
      {...rest}
      {...svgSize(height, width)}
      viewBox="0 0 35 35"
      version="1.1"
      preserveAspectRatio="xMidYMid meet">
      <G>
        <Rect fill={fill.inner} x="3" y="3" width="30" height="30" />
        <Path
          fill={fill.outer}
          d="M0.00109375,4.3334375 C0.00109375,1.9709375 1.96984375,0.0021875 4.33234375,0.0021875 L30.5801563,0.0021875 C33.0301563,0.0021875 34.9989063,1.9709375 34.9989063,4.3334375 L34.9989063,30.58125 C34.9989063,33.03125 33.0301563,35 30.5801563,35 L4.33234375,35 C1.96984375,35 0.00109375,33.03125 0.00109375,30.58125 L0.00109375,4.3334375 Z M17.54375,3.7646875 C13.9125,3.7646875 10.7625,3.9396875 7.30734375,4.4209375 C6.25734375,4.5521875 5.64484375,5.1646875 5.64484375,6.0834375 L5.64484375,26.55625 C5.64484375,27.2125 6.12609375,27.65 6.56359375,27.78125 L7.87609375,28 L7.87609375,30.75625 C7.87609375,31.0625 8.13859375,31.28125 8.48859375,31.28125 L10.5885937,31.28125 C10.8510938,31.28125 11.1135937,31.0625 11.1135937,30.75625 L11.1135937,28.30625 C12.8198438,28.525 15.1385938,28.6125 17.4573438,28.6125 C19.8198438,28.6125 22.2260938,28.525 23.8885938,28.30625 L23.8885938,30.75625 C23.8885938,31.0625 24.1948438,31.28125 24.4573437,31.28125 L26.5573438,31.28125 C26.9073438,31.28125 27.1698438,31.0625 27.1698438,30.75625 L27.1698438,28 L28.4823438,27.78125 C28.9635938,27.65 29.4010938,27.25625 29.4010938,26.55625 L29.4010938,6.0834375 C29.4010938,5.1646875 28.7885938,4.5521875 27.7385938,4.4209375 C24.2385937,3.9834375 21.0459375,3.7646875 17.5459375,3.7646875 L17.54375,3.7646875 Z M26.5989063,21.2198438 C24.1051562,21.6573437 20.8239062,22.0948438 17.63125,22.0948438 C14.2625,22.0948438 11.0698437,21.7010938 8.53234375,21.1323438 C7.83234375,21.0010938 7.56984375,20.7385938 7.56984375,20.1698438 L7.56984375,7.3959375 C7.56984375,6.8271875 7.83234375,6.4334375 8.53234375,6.4334375 L26.5989062,6.5209375 C27.2989062,6.5209375 27.5176562,6.9146875 27.5176562,7.4834375 L27.5176562,20.2573438 C27.5176562,20.8260938 27.2989062,21.1323438 26.5989062,21.2198438 L26.5989063,21.2198438 Z M8.26875,24.7198438 C8.3125,24.1510938 8.8375,23.6260938 9.45,23.6260938 C10.0625,23.6260938 10.5875,24.1510938 10.5875,24.7198438 C10.5875,25.3760938 10.0625,25.9010938 9.45,25.9010938 C8.79375,25.8573438 8.26875,25.3323438 8.26875,24.7198438 L8.26875,24.7198438 Z M24.2801563,24.7198438 C24.3239063,24.1510938 24.8489063,23.6260938 25.4176563,23.6260938 C26.0301563,23.6260938 26.5551563,24.1510938 26.5551563,24.7198438 C26.5551563,25.3760938 26.0301563,25.9010938 25.4176563,25.9010938 C24.8051563,25.8573438 24.2801563,25.3323438 24.2801563,24.7198438 Z"
          id="Bus-1"
          fillRule="nonzero"
        />
      </G>
    </Svg>
  );
}

Icon.propTypes = {
  fill: PropTypes.shape({
    inner: PropTypes.string,
    outer: PropTypes.string,
  }),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Icon.defaultProps = {
  fill: {
    inner: Colors.primary.hslWhite,
    outer: Colors.transport.bus,
  },
};

Icon.displayName = "Icons.BusRectangle";
